import styled, { css } from 'styled-components';

import { basicSmallTextStyle, Button } from '@dreryk/react-components';

export const StyledTileItemSecondaryButton = styled(Button)`
   ${basicSmallTextStyle}
   border: none;

   ${(props) => css`
      background-color: ${props.theme.success};
      color: ${props.theme.backgroundBody};
      fill: ${props.theme.backgroundBody};
   `}

   &:not(:disabled):hover {
      ${(props) => css`
         background-color: ${props.theme.successDark};
      `}
   }
`;

StyledTileItemSecondaryButton.displayName = 'StyledTileItemSecondaryButton';
